import { useModel } from "@type-r/react";
import React from "react";
import { AssetType } from "../../api/assetType";
import { CreditNote } from "../../api/creditNote";
import { CreditNoteData } from "../../api/creditNoteChange";
import { CreditNoteCount } from "../../api/creditNoteCount";
import { ConfirmAssetsDataStep } from "../confirm-assets-data-step";
import { CreditNoteForm } from "./credit-note-form";
import { CreditNoteQuery } from "./credit-note-query";
import { CreditNoteTableColumns } from "./credit-note-table-columns";
import { CreditNoteExternalSystems } from "./externalSystems";

export const ConfirmCreditNotesDataStep = ({ isEdit, job, next, cancel, startOver, $assetTypeSelect, assetTypeMultiOptions, $refreshEvents }: { isEdit: boolean, job, next?, cancel?, startOver?, $assetTypeSelect?, assetTypeMultiOptions?, $refreshEvents?}) => {
    const assetChanges = useModel(CreditNoteData);
    const creditNoteQuerryModel = useModel(CreditNoteQuery);
    const creditNoteCountModel = useModel(CreditNoteCount);

    return <>
        <ConfirmAssetsDataStep
            isEdit={isEdit}
            job={job}
            assetName="Credit Note"
            assetType={AssetType.creditNote}
            assetModel={CreditNote}
            countModel={creditNoteCountModel}
            queryModel={creditNoteQuerryModel}
            tableColumns={CreditNoteTableColumns}
            assetChanges={assetChanges}
            next={next} cancel={cancel} startOver={startOver}
            externalSystems={CreditNoteExternalSystems}
            assetForm={creditNote => <CreditNoteForm creditNote={creditNote} />}
            $assetTypeSelect={$assetTypeSelect}
            assetTypeMultiOptions={assetTypeMultiOptions}
            $refreshEvents={$refreshEvents}
        />
    </>
}
